
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pam/linux",
      function () {
        return require("private-next-pages/pam/linux.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pam/linux"])
      });
    }
  